import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.665 3.835a5.94 5.94 0 0 0 1.628 5.372L8.5 12l1.919 1.919L12 15.5a4.95 4.95 0 0 1 .019 6.981L12 22.5l-9.793-9.793a1 1 0 0 1 0-1.414zM11.98 1.52A4.95 4.95 0 0 0 12 8.5l1.707 1.707L15.5 12l-2.793 2.793a5.94 5.94 0 0 1 1.628 5.372l7.458-7.458a1 1 0 0 0 0-1.414L12 1.5l-.019.019Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSoftwareDevelopmentJira = { render };
export {
  brandSoftwareDevelopmentJira as default,
  render
};
//# sourceMappingURL=brand-software-development-jira.svg.js.map
